import {
  getListOfRoles,
  getListofResponsibility,
  getListofResponsibilityV2,
  getListOfRolesV2,
  createRole,
  createResponsibility,
  getListOfRolesAttachedToPosition,
  getListOfResponsibilitiesAttachedToRole,
} from "@/api";
import {
  getRoles,
  updateRoles,
  getResponsibilities,
  updateResponsibilities,
} from "@components/helper/localStorageHelper";
export default {
  namespaced: true,
  state: {
    roles: [],
    responsibilities: [],
    responsibilitiesCount: 0,
    ordering:
      (typeof localStorage !== "undefined" &&
        localStorage.getItem("readinessCatalogs.ordering.roles")) ||
      "name",
    responsibilitiesOrdering:
      (typeof localStorage !== "undefined" &&
        localStorage.getItem("readinessCatalogs.ordering.responsibilities")) ||
      "name",
  },
  mutations: {
    setRoles(state, data) {
      state.roles = data;
    },
    setResponsibilities(state, data) {
      state.responsibilities = data;
    },
    setResponsibilitiesCount(state, data) {
      state.responsibilitiesCount = data;
    },
    setRolesCount(state, data) {
      state.rolesCount = data;
    },
    setOrdering(state, ordering) {
      state.ordering = ordering;
      try {
        if (typeof localStorage !== "undefined") {
          localStorage.setItem("readinessCatalogs.ordering.roles", ordering);
        }
      } catch (e) {
        // ignore storage errors
      }
    },
    setResponsibilitiesOrdering(state, ordering) {
      state.responsibilitiesOrdering = ordering;
      try {
        if (typeof localStorage !== "undefined") {
          localStorage.setItem(
            "readinessCatalogs.ordering.responsibilities",
            ordering
          );
        }
      } catch (e) {
        // ignore storage errors
      }
    },
  },
  getters: {
    allRoles: (state) => state.roles,
    allResponsibilities: (state) => state.responsibilities,
    responsibilitiesCount: (state) => state.responsibilitiesCount,
    rolesCount: (state) => state.rolesCount,
    ordering: (state) => state.ordering,
    responsibilitiesOrdering: (state) => state.responsibilitiesOrdering,
    getRoleById: (state) => {
      return (roleId) => {
        const role = state.roles.find((r) => r.id == roleId);
        if (role && !role.code_str) {
          role.code_str = `#${role.code} - ${role.name}`;
        }
        return role;
      };
    },
    getAllRolesAndAttachedResponsibilities: (state) => {
      const rolesWithParentId = state.roles.map((role) => {
        // Check if code_str is null or does not exist
        if (!role?.code_str) {
          role.code_str = `#${role.code} - ${role.name}`;
        }
        return {
          ...role,
          parentId: -1,
        };
      });

      const responsibilitiesWithParentId = state.responsibilities.map(
        (responsibility) => {
          const attachedRole = responsibility.attached_roles.find(
            (attachment) =>
              state.roles.some((role) => role.id === attachment.id)
          );
          // Check if code_str is null or does not exist
          if (!responsibility?.code_str) {
            responsibility.code_str = `#${responsibility.code} - ${responsibility.name}`;
          }
          return {
            ...responsibility,
            parentId: attachedRole ? attachedRole.id : null,
          };
        }
      );

      return [...rolesWithParentId, ...responsibilitiesWithParentId];
    },
    getResponsibilitiesFromRoleId: (state) => (roleId) => {
      return state.responsibilities
        .filter((responsibility) => {
          return responsibility.attached_roles.some(
            (attachment) => attachment.id === roleId
          );
        })
        .map((responsibility) => {
          // Check if code_str is null or does not exist
          if (!responsibility?.code_str) {
            responsibility.code_str = `#${responsibility.code} - ${responsibility.name}`;
          }
          return {
            ...responsibility,
            parentId: roleId,
          };
        });
    },
  },
  actions: {
    setOrdering({ commit }, ordering) {
      commit("setOrdering", ordering);
    },
    setResponsibilitiesOrdering({ commit }, ordering) {
      commit("setResponsibilitiesOrdering", ordering);
    },
    async loadRoles({ commit }) {
      try {
        let rolesList = getRoles();
        commit("setRoles", rolesList);
        const accountId = JSON.parse(localStorage.getItem("currentAccountID"));
        await getListOfRoles(accountId, 1, 500)
          .then((response) => {
            if (response.data && response.data.results) {
              const results = response.data.results.map((role) => {
                // Check if code_str is null or does not exist
                if (!role?.code_str) {
                  role.code_str = `#${role.code} - ${role.name}`;
                }
                return {
                  ...role,
                };
              });
              updateRoles(results);
              commit("setRoles", results);
            }
          })
          .catch((error) => {
            console.error("error fetching employees: ", error);
          });
      } catch (e) {
        console.log("error fetching employees: ", e);
      }
    },
    async loadRolesV2(
      { commit, state },
      { limit, offset, search, filters = {}, ordering = null }
    ) {
      try {
        let rolesList = getRoles();
        commit("setRoles", rolesList);
        const accountId = JSON.parse(localStorage.getItem("currentAccountID"));
        await getListOfRolesV2(
          accountId,
          limit,
          offset,
          search,
          filters,
          ordering ?? state.ordering
        )
          .then((response) => {
            commit("setRolesCount", response?.data?.count);
            if (response.data && response.data.results) {
              const results = response.data.results.map((role) => {
                // Check if code_str is null or does not exist
                if (!role?.code_str) {
                  role.code_str = `#${role.code} - ${role.name}`;
                }
                return {
                  ...role,
                };
              });
              updateRoles(results);
              commit("setRoles", results);
            }
          })
          .catch((error) => {
            console.error("error fetching employees: ", error);
          });
      } catch (e) {
        console.log("error fetching employees: ", e);
      }
    },
    async loadResponsibilities({ commit }) {
      try {
        let responsibilitiesList = getResponsibilities();
        commit("setResponsibilities", responsibilitiesList);
        const accountId = JSON.parse(localStorage.getItem("currentAccountID"));
        await getListofResponsibility(accountId, 1, 500)
          .then((response) => {
            if (response.data && response.data.results) {
              const results = response.data.results.map((responsibility) => {
                // Check if code_str is null or does not exist
                if (!responsibility?.code_str) {
                  responsibility.code_str = `#${responsibility.code} - ${responsibility.name}`;
                }
                return {
                  ...responsibility,
                };
              });
              updateResponsibilities(results);
              commit("setResponsibilities", results);
            }
          })
          .catch((error) => {
            console.error("error fetching employees: ", error);
          });
      } catch (e) {
        console.log("error fetching employees: ", e);
      }
    },
    async loadResponsibilitiesV2(
      { commit, state },
      {
        limit,
        offset,
        search,
        filters = {},
        ordering = null,
        include_badge_holders = false,
      }
    ) {
      try {
        let responsibilitiesList = getResponsibilities();
        commit("setResponsibilities", responsibilitiesList);
        const accountId = JSON.parse(localStorage.getItem("currentAccountID"));

        // If searchTerm is provided, filter the results
        await getListofResponsibilityV2(
          accountId,
          limit,
          offset,
          search,
          filters,
          ordering ?? state.responsibilitiesOrdering,
          include_badge_holders
        )
          .then((response) => {
            commit("setResponsibilitiesCount", response?.data?.count);
            if (response.data && response.data.results) {
              let results = response.data.results.map((responsibility) => {
                // Check if code_str is null or does not exist
                if (!responsibility?.code_str) {
                  responsibility.code_str = `#${responsibility.code} - ${responsibility.name}`;
                }
                return {
                  ...responsibility,
                };
              });

              updateResponsibilities(results);
              commit("setResponsibilities", results);
            }
          })
          .catch((error) => {
            console.error("error fetching employees: ", error);
          });
      } catch (e) {
        console.log("error fetching employees: ", e);
      }
    },
    async createRole(context, { role, accountId }) {
      try {
        const { data } = await createRole(accountId, role);
        if (data) {
          return data;
        }
      } catch (e) {
        console.log("e: ", e);
      }
    },
    async createResponsibility(context, { name, accountId }) {
      try {
        const payload = {
          name: name,
          account: accountId,
        };
        const newRes = await createResponsibility(accountId, payload);
        return newRes;
      } catch (e) {
        console.log("e: ", e);
      }
    },
    async loadRolesAttachedToPosition(
      { commit },
      { limit, offset, search, filters = {}, positionId }
    ) {
      try {
        let rolesList = getRoles();
        commit("setRoles", rolesList);
        const accountId = JSON.parse(localStorage.getItem("currentAccountID"));
        await getListOfRolesAttachedToPosition(
          accountId,
          limit,
          offset,
          search,
          filters,
          positionId
        )
          .then((response) => {
            commit("setRolesCount", response?.data?.count);
            if (response.data && response.data.results) {
              const results = response.data.results.map((role) => {
                // Check if code_str is null or does not exist
                if (!role?.code_str) {
                  role.code_str = `#${role.code} - ${role.name}`;
                }
                return {
                  ...role,
                };
              });
              updateRoles(results);
              commit("setRoles", results);
            }
          })
          .catch((error) => {
            console.error("error fetching employees: ", error);
          });
      } catch (e) {
        console.log("error fetching employees: ", e);
      }
    },
    async loadResponsibilitiesAttachedToRole(
      { commit },
      {
        limit,
        offset,
        search,
        filters = {},
        roleId,
        include_badge_holders = false,
      }
    ) {
      try {
        let rolesList = getRoles();
        commit("setRoles", rolesList);
        const accountId = JSON.parse(localStorage.getItem("currentAccountID"));
        await getListOfResponsibilitiesAttachedToRole(
          accountId,
          limit,
          offset,
          search,
          filters,
          roleId,
          include_badge_holders
        )
          .then((response) => {
            commit("setResponsibilitiesCount", response?.data?.count);
            if (response.data && response.data.results) {
              const results = response.data.results.map((responsibility) => {
                // Check if code_str is null or does not exist
                if (!responsibility?.code_str) {
                  responsibility.code_str = `#${responsibility.code} - ${responsibility.name}`;
                }
                return {
                  ...responsibility,
                };
              });
              updateResponsibilities(results);
              commit("setResponsibilities", results);
            }
          })
          .catch((error) => {
            console.error("error fetching employees: ", error);
          });
      } catch (e) {
        console.log("error fetching employees: ", e);
      }
    },
  },
};
